export default __webpack_public_path__ + "08b609b216807c2d7e5f31b1daa152e5.png";